export default "__VITE_ASSET__B4ruK11z__"